'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'ProcessingJob',
  basePath: ':basePath',
  endpoint: 'processing_jobs',
  debug: false,
  methods: null,
  relations : {

  }
};

var ProcessingJobResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'ProcessingJob',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
    },

    modelMethods: {
    },

    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    syncTriggers: {}
  };
};

module.exports = ProcessingJobResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/processingJob/ProcessingJobResource.js